import { StoreManager } from '@hypereact/state';
import { DesignSystemTranslatorManager } from '@managers/FacadeTranslatorManager';
import { LanguageManager } from '@managers/language.manager';
import { reduxConfig } from '@store/configure';
import KeycloakUtil from '@utils/keycloak.util';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './_shared/theme/custom_bootstrap.scss';
import './_shared/utils/interceptors.util';

(async () => {
    const storeManager = StoreManager.getInstance(reduxConfig);
    await storeManager.waitUntilReady();

    const locales = await LanguageManager.loadLocales();

    DesignSystemTranslatorManager.getInstance(LanguageManager.getInstance(locales));

    const renderApp = () =>
        ReactDOM.render(
            <React.StrictMode>
                <IntlProvider locale='en' messages={locales}>
                    <Provider store={storeManager.getStore()}>
                        <App />
                    </Provider>
                </IntlProvider>
            </React.StrictMode>,
            document.getElementById('root'),
        );

    KeycloakUtil.initKeycloak(renderApp, storeManager.getState('login').isLogged);
})();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
